<template>
  <!-- <div
    style="
      background: url('/img/bg-1.png') no-repeat center fixed;
      background-size: cover;
      overflow-x: hidden;
    "
  > -->
  <div>
    <div class="wrapper wrapper-full-page">
      <div class="full-page">
        <div class="content">
          <div class="row">
            <div class="col-lg"></div>
            <div class="col-lg-3">
              <card style="background-color: white; box-shadow: none">
                <div class="row">
                  <div class="col-lg">
                    <h3
                      slot="header"
                      style="margin-bottom: -15px; color: #358CCB"
                    >
                      Recover Password
                    </h3>
                    <el-divider></el-divider>
                    <p style="color: #b9b9b9">
                      Please enter your new password.
                    </p>
                  </div>
                </div>
                <br />
                <div class="row text-center">
                  <div class="col-lg">
                    <p style="color: #b9b9b9">Password</p>
                    <div style="margin-top: -35px; padding-left:400px; display: flex">
                  <el-tooltip effect="light" :open-delay="300" placement="top">
                    <template v-slot:content>
                      <div style="display: flex">
                        <p style="font-style: italic; font-size: 11px; color: #5a5a5a;">
                          <i v-if="!alphanumeric" class="fas fa-times-circle red-circle"></i>
                          <i v-if="alphanumeric" class="fas fa-check-circle green-circle"></i>
                          At least 8 alphanumeric characters
                        </p>
                        &nbsp;&nbsp;
                      </div>
                      <div style="display: flex">
                        <p style="font-style: italic; font-size: 11px; color: #5a5a5a;">
                          <i v-if="!upperlower" class="fas fa-times-circle red-circle"></i>
                          <i v-if="upperlower" class="fas fa-check-circle green-circle"></i>
                          Must include uppercase and lowercase
                        </p>
                      </div>
                      <div style="display: flex">
                        <p style="font-style: italic; font-size: 11px; color: #5a5a5a;">
                          <i v-if="!special" class="fas fa-times-circle red-circle"></i>
                          <i v-if="special" class="fas fa-check-circle green-circle"></i>
                          Must include symbol (e.g. !@#$%^&*)
                        </p>
                      </div>
                    </template>
                    <base-button type="link">
                      <i class="tim-icons icon-alert-circle-exc"></i>
                    </base-button>
                  </el-tooltip>
                </div>
                    <base-input
                      :inputStyle="inputstyle"
                      v-model="password"
                      placeholder="Password"
                      required
                      :type="showPassword ? 'text' : 'password'"
                    ></base-input>
                    
                    <div style="color: #b9b9b9; text-align: right">
                      <input type="checkbox" v-model="showPassword" /> Show
                      Password
                    </div>
                  </div>
                </div>
                <div class="row text-center">
                  <div class="col-lg">
                    <p style="color: #b9b9b9">Re-type Password</p>
                    <!-- <div style="margin-top: -35px; padding-left:400px; display: flex">
                  <el-tooltip effect="light" :open-delay="300" placement="top">
                    <template v-slot:content>
                      <div style="display: flex">
                        <p style="font-style: italic; font-size: 11px; color: #5a5a5a;">
                          <i v-if="!alphanumeric2" class="fas fa-times-circle red-circle"></i>
                          <i v-if="alphanumeric2" class="fas fa-check-circle green-circle"></i>
                          At least 8 alphanumeric characters
                        </p>
                        &nbsp;&nbsp;
                      </div>
                      <div style="display: flex">
                        <p style="font-style: italic; font-size: 11px; color: #5a5a5a;">
                          <i v-if="!upperlower2" class="fas fa-times-circle red-circle"></i>
                          <i v-if="upperlower2" class="fas fa-check-circle green-circle"></i>
                          Must include uppercase and lowercase
                        </p>
                      </div>
                      <div style="display: flex">
                        <p style="font-style: italic; font-size: 11px; color: #5a5a5a;">
                          <i v-if="!special2" class="fas fa-times-circle red-circle"></i>
                          <i v-if="special2" class="fas fa-check-circle green-circle"></i>
                          Must include symbol (e.g. !@#$%^&*)
                        </p>
                      </div>
                    </template>
                    <base-button type="link">
                      <i class="tim-icons icon-alert-circle-exc"></i>
                    </base-button>
                  </el-tooltip>
                </div> -->
                    <base-input
                      :inputStyle="inputstyle"
                      v-model="repassword"
                      placeholder="Re-type Password"
                      required
                      :type="showPassword1 ? 'text' : 'password'"
                    ></base-input>
                    <div style="color: #b9b9b9; text-align: right">
                      <input type="checkbox" v-model="showPassword1" /> Show
                      Password
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg">
                    <p style="color: #fb0000; font-size: 11px; margin-left: 20px; margin-top: -25px;">{{ message }}</p>
                  </div>
                </div>
                <div class="row text-right">
                  <div class="col-lg">
                    <base-button type="danger" v-on:click="getLogin()"
                      >Back</base-button
                    >
                    <base-button
                      :disabled="buttondisabled"
                      type="primary"
                      @click="resetpassword()"
                    >
                      Submit</base-button
                    >
                  </div>
                </div>
              </card>
            </div>
            <div class="col-lg"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import swal from "sweetalert2";
import { Divider } from "element-ui";

export default {
  name: "RecoverPassword",
  components: {
    [Divider.name]: Divider,
  },
  data() {
    return {
      alphanumeric: false,
      upperlower: false,
      special: false,
      alphanumeric2: false,
      upperlower2: false,
      special2: false,
      showPassword: false,
      showPassword1: false,
      password: "",
      repassword: "",
      message: "",
      buttondisabled: false,
      inputstyle:
        "height: 35px;  border-radius: 50px; border: 1px solid #e3e3e3;",
    };
  },
  methods: {
    checkPassword(value) {
      const alphanumericPattern = /^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9!@#$%^&*]{8,}$/;
      const hasUppercase = /[A-Z]/.test(value);
      const hasLowercase = /[a-z]/.test(value);
      const hasSpecialChar = /[!@#$%^&*]/.test(value);

      if (alphanumericPattern.test(value)) {
        this.alphanumeric = true;
      }
      else if (!alphanumericPattern.test(value)) {
        this.alphanumeric = false;
      }

      if (hasUppercase && hasLowercase) {
        this.upperlower = true;
      } else if (!hasUppercase || !hasLowercase) {
        this.upperlower = false;
      }

      if (hasSpecialChar) {
        this.special = true;
      } else if (!hasSpecialChar) {
        this.special = false;
      }

      console.log(this.message)
    },

    checkPassword2(value) {
      const alphanumericPattern = /^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9!@#$%^&*]{8,}$/;
      const hasUppercase = /[A-Z]/.test(value);
      const hasLowercase = /[a-z]/.test(value);
      const hasSpecialChar = /[!@#$%^&*]/.test(value);

      if (alphanumericPattern.test(value)) {
        this.alphanumeric2 = true;
      }
      else if (!alphanumericPattern.test(value)) {
        this.alphanumeric2 = false;
      }

      if (hasUppercase && hasLowercase) {
        this.upperlower2 = true;
      } else if (!hasUppercase || !hasLowercase) {
        this.upperlower2 = false;
      }

      if (hasSpecialChar) {
        this.special2 = true;
      } else if (!hasSpecialChar) {
        this.special2 = false;
      }

      console.log(this.message)
    },
    getLogin() {
      this.$router.push("/login");
    },
    resetpassword() {
      console.log("hot");
      let obj = {
        email: this.$route.query.email,
        token: this.$route.query.token,
        password: this.password,
        confirm_password: this.repassword,
      };
      this.$http
        .post(":10001/api/v1/password/change", obj)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            swal({
              title: `Success!`,
              text: response,
              buttonsStyling: false,
              confirmButtonClass: "btn btn-primary btn-fill",
              type: "success",
            }).then((result) => {
              console.log(result);
              if (result.value) {
                this.$router.push("/login");
              }
            });
          }
        })
        .catch((err) => {
          swal({
            title: `Error!`,
            text: err.response.data.message,
            buttonsStyling: false,
            confirmButtonClass: "btn btn-cancel btn-fill",
            type: "error",
          });
        });
    },
  },
  watch: {
    password(newValue) {
      this.checkPassword(newValue);
    },

    password2(newValue) {
      this.checkPassword2(newValue);
    },
    repassword() {
      console.log(this.message);
      if (this.password != this.repassword) {
        this.message = "Password mismatch.";
        this.buttondisabled = true;
      }

      if (this.password == this.repassword) {
        this.message = "";
        this.buttondisabled = false;
      }
    },
  },
  created() {
    console.log(this.$route.query.token);
    console.log(this.$route.query.email);
  },
};
</script>

<style>
.custom-value {
  border: none;
  color: #000000;
  font-size: 20px;
  font-weight: 600;
  border-bottom: 1px solid #cecece;
  width: 40%;
  background-color: transparent;
}

.custom-value:active {
  border: 0;
  border-bottom: 1px solid #cecece;
  background-color: transparent;
}

.custom-value:hover {
  border: 0;
  border-bottom: 1px solid #cecece;
  background-color: transparent;
  cursor: pointer;
}
.custom-value:target {
  border: 0;
  border-bottom: 1px solid #cecece;
  background-color: transparent;
}

.custom-value:focus {
  border: 0;
  border-bottom: 1px solid #cecece;
  background-color: transparent;
}
.red-circle {
  color: #EC1B23;
  font-size: 12px;
}

.green-circle {
  color: #0BAA00;
  font-size: 12px;
}
</style>
